import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoEstructuraDel = async (credentials, data) => {
  const body = {
    service: "RNHEstablecimientoEstructuraDel",
    params: {
      rnhEstablecimientoEstructuraId: data?.id || null,
      rnhEstablecimientoEstructuraVersion: data?.version ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
